// Minimal rich-text helpers for question labels (Word-style formatting).

const ALLOWED_TAGS = new Set([
  "B", "STRONG", "I", "EM", "U", "S", "STRIKE", "BR", "P", "DIV", "SPAN",
  "UL", "OL", "LI", "SUB", "SUP", "FONT",
]);

/** Strip scripts, event handlers and unknown tags — keeps Word-like formatting only. */
export function sanitizeRichHtml(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  const walk = (node) => {
    [...node.children].forEach((el) => {
      if (!ALLOWED_TAGS.has(el.tagName)) {
        // unwrap unknown tags but keep their children/text
        while (el.firstChild) node.insertBefore(el.firstChild, el);
        el.remove();
        return;
      }
      [...el.attributes].forEach((a) => el.removeAttribute(a.name));
      walk(el);
    });
  };
  walk(doc.body);
  return doc.body.innerHTML;
}

/** Plain text version of a rich label (for PDFs, dropdowns, validation). */
export function htmlToText(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}
